import React from 'react';

import NavArrow from '../../shared/components/nav-arrow';
import { Carousel } from '../../shared/components/carousel';
import { withError } from '../../shared/components/error-boundary';
import XSellProductCard from './tabs/xsell-product-card';


class AccessoriesCarousel extends React.Component {
    constructor(props) {
        super(props);
    }

    controls() {
        return {
            renderCenterLeftControls : NavArrow.PrevArrow,
            renderCenterRightControls: NavArrow.NextArrow,
            renderBottomCenterControls: () => <div></div>
        }
    }

    render(){
        const settings = {
            slidesToShow: this.props.slidesToShow || 3,
            slidesToScroll: this.props.slidesToShow || 1,
            ...this.controls(),
            initialSlideHeight: 480
        }
        const { products, carouselRef } = this.props;
        return(
            <div className={`acc-carousel${this.props.className ? ' '+this.props.className : ''}`}>
                <div className='pdp-acc-list'>
                    <Carousel {...settings} ref={ carouselRef }>
                        {products.map((product, i) =>
                            <XSellProductCard
                                key={product.sku}
                                product={product}
                                setCarouselHeight={() => this.props.setCarouselHeight() }
                            />
                        )}
                    </Carousel>
                </div>
                <div className='pdp-acc-list-mobile'>
                    {products.map((product, i) =>
                        <XSellProductCard
                            key={'mobile'+product.sku+i}
                            product={product}
                        />
                    )}
                </div>
            </div>
        )
    }
}

export default withError(AccessoriesCarousel);
